import { ActivatedRoute } from '@angular/router'
import { DestroyRef, WritableSignal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

export type ContentState = 'none' | 'create' | 'view' | 'edit' | 'duplicate'

/**
 * Sets up a route listener to update the content state of a manager and a component based on the current URL.
 * Used to differentiate between 'create', 'none', and 'view' states.
 *
 * @param route The ActivatedRoute to listen to.
 * @param destroyRef The DestroyRef for clean up.
 * @param managerContentState The WritableSignal from the manager service.
 * @param componentContentState The WritableSignal from the component.
 */
export function setupContentStateRouteListener<T extends ContentState>(
  route: ActivatedRoute,
  destroyRef: DestroyRef,
  managerContentState: WritableSignal<T>,
  componentContentState: WritableSignal<T>
): void {
  route.url.pipe(takeUntilDestroyed(destroyRef)).subscribe(() => {
    if (route.snapshot.url.some(s => s.path === 'create')) {
      managerContentState.set('create' as T)
      componentContentState.set('create' as T)
    } else if (route.snapshot.paramMap.get('uuid') === null) {
      managerContentState.set('none' as T)
      componentContentState.set('none' as T)
    } else {
      managerContentState.set('view' as T)
      componentContentState.set('view' as T)
    }
  })
}
